import React from 'react'

import TradeInContextContainer from './TradeInContextContainer'
import TradeInContainer from './TradeInContainer'

export default () => (
  <TradeInContextContainer>
    <TradeInContainer data-test="component-tradeIn-index" />
  </TradeInContextContainer>
)
